import React from "react";
// Consumer Consumption Trends

// Custom
import DashboardCard from "../card/DashboardCard";
import ConsumerConsumptionLineChart from "../charts/ConsumerConsumptionLineChart";
import { ChartLine } from "lucide-react";

// Svg

const ConsumerConsumptionTrends: React.FC = () => {
  return (
    <DashboardCard
      title={"Consumption Analysis Trends"}
      className={"consumer_consumption_trends"}
      body={<ConsumerConsumptionLineChart />}
      sx={{
        borderWidth: "1px",
        borderColor: "#E0E0E0",
        m: 2,
      }}
      titleIcon={<ChartLine />}
    />
  );
};

export default ConsumerConsumptionTrends;
